export const isLocalEnvironment = (): boolean => window.location.hostname.includes("localhost");
